module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/wQLoU2/tc-custom/9781446357347.jpg?1705766123450",
      "alt": "This image is the cover for the book Make Me I'm Yours ... Sewing"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Make Me I'm Yours ... Sewing\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Learn how to sew with this stylish collection of twenty irresistible hand and sewing machine projects, including bags, gifts, and pillows.")]), _c('br'), _c('br'), _vm._v("Discover the pleasure of making your own chic and unique designs with these simple-to-make patterns. Transform yourself from a needlecraft novice to an embellishment expert with this sewing savvy guide. Choose from pretty and stylish gift ideas for you and your friends and go fabric shopping today."), _c('br'), _c('br'), _vm._v("This book is packed with ideas, needlecraft techniques, step-by-step instructions, and handy tips to make it fun and easy. It has ideas for you and your home, from beautiful bags to vibrant cushions. Everyone will find a project they adore.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Various\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    David & Charles Book\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0